export default (kasko) => {
  kasko.addEventListener(
    'state-changed',
    (policyStartDate) => {
      const { lead_token_exists: leadTokenExists } = kasko.getState('flags');

      if (!policyStartDate || leadTokenExists) return;

      kasko.dispatchEvent('set-state-input', {
        policy_end_date_human: undefined,
      });
      kasko.dispatchEvent('set-form-input', {
        policy_end_date_human: undefined,
      });
    },
    {
      slice: 'input.policy_start_date',
    },
  );
};
